import { ErrorContainer, ErrorBody, ErrorLogo } from "./Error.style";
import logo from "../images/logo.png";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import ExternalLinkButton from "./ExternalLinkButton";

const isHtmlString = (value) => typeof value === "string" || value == null;

const Error = ({ title, message, button, height, showLogo = true, size = 'lg' }) => {
  const { t } = useTranslation()
  return (
    <ErrorContainer height={height} size={size}>
      { showLogo && <ErrorLogo src={logo} alt="Social Scavenger" /> }
      <ErrorBody size={size}>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        {isHtmlString(title)
          ? <h1 dangerouslySetInnerHTML={{ __html: title || "Error" }} />
          : <h1>{title || "Error"}</h1>}
        {isHtmlString(message)
          ? <p dangerouslySetInnerHTML={{ __html: message }} />
          : message}
        {button || (
          <ExternalLinkButton color="primary" href="https://www.socialscavenger.com/contact/">
            {t("Contact Support")}
          </ExternalLinkButton>
        )}
      </ErrorBody>
    </ErrorContainer>
  );
};

export default Error;
